
<div class="single-line-toast">
  @switch (data.status) {
    @case (ERROR) {
      <div class="toast-content-row">
        <div class="toast-icon-frame">
          <img class="toast-icon" src="assets/images/error-white.svg" />
        </div>
        <div class="toast-text-frame">
          <span class="toast-message" [innerHTML]="data.message">{{ data.message }}</span>
        </div>
        @if (data?.error) {
          <button
            class="btn btn-position toast-action"
            (click)="openErrorPopup()"
            matTooltip="Click for more information"
          >
            <img class="h-20" src="assets/images/infoWhiteFilled.svg" />
          </button>
        }
      </div>
    }
    @case (ERROR_LIGHT) {
      <div class="toast-content-row">
        <div class="toast-icon-frame">
          <img class="toast-icon" src="assets/images/cross-icon.svg" />
        </div>
        <div class="toast-text-frame">
          <span class="toast-message" [innerHTML]="data.message">{{ data.message }}</span>
        </div>
        @if (data?.error) {
          <button
            class="btn btn-position toast-action"
            (click)="openErrorPopup()"
            matTooltip="Click for more information"
          >
            <img class="h-20" src="assets/images/info-teal.svg" />
          </button>
        }
      </div>
    }
    @case ('CROSS_ICON_ERROR') {
      <div class="toast-content-row">
        <div class="toast-icon-frame">
          <img class="cross-error-icon" src="assets/images/cross-icon.svg" />
        </div>
        <div class="toast-text-frame">
          <span class="toast-message" [innerHTML]="data.message">{{ data.message }}</span>
        </div>
      </div>
    }
    @default {
      @if (data?.first_msg && data?.message) {
        <div class="toast-content-stack">
          <div class="toast-content-row">
            <div class="toast-icon-frame">
              <img class="toast-icon" src="assets/images/success_tick.svg" />
            </div>
            <div class="toast-text-frame">
              <span class="toast-message" [innerHTML]="data?.first_msg">{{ data?.first_msg }}</span>
            </div>
          </div>
          <div class="toast-content-row">
            <div class="toast-icon-frame">
              <img class="toast-icon" src="assets/images/success_tick.svg" />
            </div>
            <div class="toast-text-frame">
              <span class="toast-message" [innerHTML]="data?.message">{{ data?.message }}</span>
            </div>
          </div>
        </div>
      } @else {
        <div class="toast-content-row">
          @if (
            data?.autogenerationMessage ||
            data?.errorMessage ||
            data?.deleteMessage ||
            ((data?.first_msg && data?.first_msg !== AUTO_GENERATE_MESSAGES.THANK_YOU_MSG) || (!data?.first_msg && data?.message && data?.message !== AUTO_GENERATE_MESSAGES.THANK_YOU_MSG))
          ) {
            <div class="toast-icon-frame">
              @if (data?.autogenerationMessage) {
                <img class="h-14 w-16" src="assets/images/ai-sparkle.svg" />
              } @else if (data?.errorMessage) {
                <img class="toast-icon" src="assets/images/cross-icon.svg" />
              } @else if (data?.deleteMessage) {
                <img class="toast-icon" src="assets/images/delete_light.svg" />
              } @else if ((data?.first_msg && data?.first_msg !== AUTO_GENERATE_MESSAGES.THANK_YOU_MSG) || (!data?.first_msg && data?.message && data?.message !== AUTO_GENERATE_MESSAGES.THANK_YOU_MSG)) {
                <img class="toast-icon" src="assets/images/success_tick.svg" />
              }
            </div>
          }
          <div class="toast-text-frame">
            <span
              class="toast-message"
              [innerHTML]="data?.first_msg || data?.message || data?.errorMessage || data?.deleteMessage || data?.autogenerationMessage || data?.onlyText"
            >
              {{ data?.first_msg || data?.message || data?.errorMessage || data?.deleteMessage || data?.autogenerationMessage || data?.onlyText }}
            </span>
          </div>
        </div>
      }
    }
  }
</div>
